import { Component, OnInit, inject } from '@angular/core';
import { Background } from '../../shared/components/background/background';
import { Connect } from '../../shared/components/connect/connect';
import { HeroSection } from '../../shared/components/hero-section/hero-section';
import { InfoCard } from '../../shared/components/info-card/info-card';
import { Button } from '../../shared/components/button/button';
import { Router } from '@angular/router';
import { Process } from './components/process/process';
import { SeoService } from '../../shared/services/seo.service';

@Component({
  selector: 'app-website-marketing-services',
  imports: [Background, HeroSection, Process, InfoCard, Button, Connect],
  templateUrl: './website-marketing-services.html',
  styleUrl: './website-marketing-services.scss'
})
export class WebsiteMarketingServices implements OnInit {

  protected file = 'website-marketing';

  private router = inject(Router);
  private seo = inject(SeoService);

  ngOnInit() {
    this.seo.apply({
      title: 'Website Marketing Services',
      description: 'SEM Nexus boosts traffic and conversions with targeted website marketing, paid ads, influencers, and messaging aligned with app growth strategy.',
      canonical: '/website-marketing-services/',
      image: 'https://semnexus.com/images/website-marketing/backgrounds/website-marketing.avif',
      imageAlt: 'Website marketing services by SEM Nexus',
      type: 'website',
    });
    this.seo.setBreadcrumbs([
      { name: 'Home', url: '/' },
      { name: 'Website Marketing' },
    ]);
    this.seo.setJsonLd('service', {
      '@context': 'https://schema.org',
      '@type': 'Service',
      '@id': 'https://semnexus.com/website-marketing-services/#service',
      name: 'Website Marketing',
      serviceType: 'Conversion-focused website strategy and execution',
      description: 'Conversion-focused website strategy and execution — traffic, on-page experience, paid acquisition aligned with app growth.',
      provider: { '@id': 'https://semnexus.com/#organization' },
      areaServed: { '@type': 'Country', name: 'United States' },
      url: 'https://semnexus.com/website-marketing-services/',
    });
  }

  goToCaseStudies() {
    this.router.navigate(['marketing-case-studies']);
  }
}
